module.exports = __webpack_public_path__ + "img/travel-insurance-help.1c86ae12.webp";